import OrgaLogo from '@betterplace/assets/images/logos/orga-logo.svg'
import classNames from 'classnames'
import styles from './HeaderCompact.module.css'
import { DefaultImage, DefaultLink } from '../shared'
import { getSafeImageSource } from '../../utils'
import type { CSSProperties } from 'react'
import type { HeaderCompactProps } from './types'
const logo = getSafeImageSource(OrgaLogo)
const logoSize = 175
function HeaderCompact({
  Link = DefaultLink,
  Image = DefaultImage,
  text,
  children,
  className,
  hideClaim,
}: HeaderCompactProps) {
  return (
    <header
      style={{ ['--logo-size']: `${logoSize}px` } as CSSProperties}
      className={classNames(styles.header, 'bp-shared', { [styles.claimHidden!]: hideClaim }, className)}
    >
      <div className={styles.inner}>
        <div className={styles.headerLogo}>
          <Link href={text.homePageUrl} className={styles.headerLogoLink}>
            <div className={styles.imageContainer}>
              <Image src={logo} alt={text.logoAlt} width={logoSize} className={styles.logoDesktop} />
            </div>
          </Link>
        </div>
        <div className={styles.headerClaim} data-axe-expect="color-contrast">
          {text.claim}
        </div>
        {children}
      </div>
    </header>
  )
}

export default HeaderCompact
